import { css as t } from "lit";
const n = t`
  :focus-visible {
    outline: 2px solid var(--kl-accent, #0d9488);
    outline-offset: 2px;
  }
`, o = t`
  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      transition-duration: 0.01ms !important;
      transform: none !important;
    }
  }
`, r = t`
  .kl-label {
    font-family: var(--kl-font-sans, 'DM Sans', system-ui, sans-serif);
    font-size: var(--kl-text-xs, 0.64rem);
    font-weight: var(--kl-weight-medium, 500);
    letter-spacing: var(--kl-tracking-label, 0.08em);
    text-transform: uppercase;
  }
`;
export {
  n as focusRing,
  r as labelType,
  o as reducedMotion
};
